/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentOperationResponseDto } from '../../models/document-operation-response-dto';
import { S3EventDocumentDto } from '../../models/s-3-event-document-dto';

export interface DocumentsControllerHandleS3Event$Params {
      body: S3EventDocumentDto
}

export function documentsControllerHandleS3Event(http: HttpClient, rootUrl: string, params: DocumentsControllerHandleS3Event$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentOperationResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentsControllerHandleS3Event.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentOperationResponseDto>;
    })
  );
}

documentsControllerHandleS3Event.PATH = '/thalea-documents/documents/s3-event';
